module.exports = __webpack_public_path__ + "img/waiting.a8dc20bd.png";